import React from 'react';
import { Container } from 'react-bootstrap';
import { FaBriefcase } from 'react-icons/fa';

function Experience() {
  const experiences = [
    {
      company: 'ADP',
      role: 'Chief App Dev',
      location: 'Greater Atlanta Area',
      description:
        'Leading architecture and development for a team working on a cutting-edge customer portal that integrates employee information with complex back-end systems. Utilizing Angular, MongoDB, REST APIs and disparate back-end systems, with heavy emphasis on unit and e2e testing. Platform utilizing Git, Jenkins, and custom-built deployment/PR management.',
    },
    {
      company: 'John West Consulting',
      role: 'Independent Consultant',
      location: 'Various',
      description:
        'Business and technology consulting, specializing in large and small application development. Full-stack development, from backend database and services to front-end Angular applications. Led efforts around large ecommerce businesses, including development, integration, advertising, marketing and SEO. Clients include Tutorshops, Florida Blue (BCBSFL), BigSkyTool, PeopleNet, Graham Field.',
    },
    {
      company: 'John West Consulting',
      role: 'Technical Trainer',
      location: 'Worldwide',
      description:
        'Technical remote and onsite classroom training to developers on frameworks such as AngularJS. Sharing concepts and techniques used to architect and implement professional applications for businesses from startups to Fortune 500 clients.',
    },
    {
      company: 'Intellinet',
      role: 'Principal Consultant',
      location: 'Atlanta, GA',
      description:
        'Architected and developed applications for a multitude of clients including Coca-Cola Enterprises, Cox Communications and Blue Cross Blue Shield. Managed teams, gathered requirements and architected systems to ensure delivery success.',
    },
  ];

  return (
    <section id="experience" className="experience-section section-padding">
      <Container>
        <div className="section-divider"></div>
        <h2 className="section-title">Experience</h2>
        <p className="section-subtitle">A track record of delivering impactful solutions</p>

        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-card">
                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                  <div>
                    <h4>{exp.role}</h4>
                    <p className="company">
                      <FaBriefcase className="me-2" style={{ fontSize: '0.9rem' }} />
                      {exp.company}
                    </p>
                  </div>
                  <div className="text-end">
                  </div>
                </div>
                <p className="period">
                  {exp.location}
                </p>
                <p className="description">{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Experience;
